module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch13"
    }
  }, [_c('b', [_vm._v("Sports Milestones")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Most strikeouts thrown in one baseball game: 21, by the Washington Senators’ Tom Cheney, in 16 innings (1962).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1954, Roger Bannister was the first person to run a mile in under four minutes, with a time of 3:59.4.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Ray Harroun was the first winner of the Indianapolis 500, in 1911.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1986, American Greg LeMond became the first non-European to win the Tour de France.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Tallest golfer to play on the PGA Tour: Phil Blackmar (6'7\").")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1981, John Henry was the first Thoroughbred to win a million-dollar race.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1926, Gertrude Ederle became the first woman to swim the English Channel. Only five men had done it before her.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Most seasons as a major-league baseball umpire: Bill Klem and Bruce Froemming, each with 37 years.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First Asian American woman to win an Olympic gold medal: figure skater Kristi Yamaguchi, in 1992.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The winner of the first Kentucky Derby was Aristides, ridden by Oliver Lewis, on May 17, 1875.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First basketball player to enter the NBA directly from high school: Reggie Harding in 1962.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first Ironman Triathlon was held in Hawaii in 1978.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The New York Yankees have won 26 championships, more than any other professional sports team.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Late 19th-century boxer John L. Sullivan was the first American sports figure to become a national celebrity.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b72d11ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter13.vue
// module id = 111
// module chunks = 0